import React from 'react';
import { Card, Stack, Text } from '@chaser/components';
import { ShieldX } from 'lucide-react';
import PageContainer from '../../../components/PageContainer';
import styles from './InsufficientPermissions.module.scss';

const InsufficientPermissions = ({ message }) => {
  return (
    <PageContainer>
      <div className={styles.wrapper}>
        <Card p={0} className={styles.card}>
          <Stack alignItems="center" gap="small" className={styles.cardBody}>
            <div className={styles.iconCircle}>
              <ShieldX size={24} strokeWidth={2.5} />
            </div>
            <Text as="h2" fontSize="large" fontWeight="bold">
              Insufficient permissions
            </Text>
            <Text as="p">
              { message }
            </Text>
          </Stack>
        </Card>
      </div>
    </PageContainer>
  );
};

export default InsufficientPermissions;
